import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export const convertServiceDocumentFormValuesToKnmData = (values: IKnmErknmForm): IKnm248['serviceDocument'] => {
  const { serviceDocument } = values;

  if (!serviceDocument) {
    return null;
  }

  return {
    active: serviceDocument.active || null,
    attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(serviceDocument.attachments),
    correlationToken: serviceDocument.correlationToken || null,
    description: serviceDocument.description || null,
    descriptionReactQuillEditor: handleReactQuillDeltaValue(
      serviceDocument.descriptionReactQuillEditor || serviceDocument.description,
    ),
    guid: serviceDocument.guid || null,
    type: null,
  };
};
